import { appRouterPaths } from "@/services/navigation";
import { CommitmentsPage } from "@/pages/CommitmentsPage";
import type { RouteProps } from "react-router-dom";

export const commitmentsPageRoute: RouteProps = {
  path: appRouterPaths.commitments,
  element: <CommitmentsPage />,
};
